tailwind.config = {
    theme: {
        extend: {
            keyframes: {
                appear: {
                    "0%": {
                        opacity: "1",
                    },
                    "100%": {
                        opacity: "0",
                    },
                },
            }
        }
    }
}